var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"format0103"},[_c('div',{staticClass:"format01"},[_c('div',{staticClass:"format-cover"},[_c('div',{staticClass:"format-img-box"},[(_vm.format.img == '')?_c('p',[_vm._v("画像が登録されていません")]):_c('img',{staticClass:"format-img",attrs:{"src":_vm.rt+_vm.uploadsFolder+_vm.format.img}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }